import { render, staticRenderFns } from "./EditIconButton.vue?vue&type=template&id=13dca1c8&"
import script from "./EditIconButton.vue?vue&type=script&lang=ts&"
export * from "./EditIconButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports